import Repository from "../../repository";

export default {
    GetLampHistories: (payload) => Repository.post(`/api/LightingHistories/GetLampHistories`, payload),
    GetCabinetHistories: (payload) => Repository.post(`/api/LightingHistories/GetCabinetHistories`, payload),
}
